var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1412 436L1412 464",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1412.5,
    cy: 431.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.99 431.19C1407.99 427.283 1411.29 424.117 1415.36 424.117C1415.94 424.117 1416.51 424.184 1417.06 424.308C1415.74 423.48 1414.19 423 1412.52 423C1407.81 423 1404 426.806 1404 431.5C1404 436.194 1407.81 440 1412.52 440C1414.81 440 1416.89 439.093 1418.43 437.62C1417.49 438.032 1416.45 438.263 1415.36 438.263C1411.29 438.263 1407.99 435.096 1407.99 431.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.4 430.6L1421.37 428.146L1419.54 429.719L1417.3 429.056L1418.11 431.337L1416.77 433.381L1419.1 433.218L1420.5 435.144L1421.13 432.763L1423.34 431.909L1421.4 430.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.85f25a60f8ce263727fda929d0ec6748.svg";
export { ForwardRef as ReactComponent };